import {
  ACTION_GET_BONUS,
  ACTION_POST_CREATE_BONUS,
  ACTION_PUT_UPDATE_BONUS,
  ACTION_DELETE_BONUS,
  SET_BONUS,
} from "@/views/bonus/store/types/types.js";

import config from "@/views/bonus/config/bonus_api.js";
import PathUri from "@/utils/path_uri";
import axios from "@/plugins/http/axios.js";
import Swal from "sweetalert2";
//import EventBus from '@/utils/event_bus.js';

import { BonusService } from "../../../services";

const _pathUri = new PathUri(config.port, config.context);

const actions = {

  [ACTION_GET_BONUS]: async ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      try {
        state.loading = true;

        const idGroup = sessionStorage.getItem("idGroup");
        const userId = sessionStorage.getItem("idUsuario");
        const companyId = sessionStorage.getItem("idEmpresa");
        BonusService.getAllBonus(idGroup, companyId, userId)
          .then(async (resp) => {
            commit(SET_BONUS, resp.data.payload);
            resolve(resp);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            state.loading = false;
          });
      } catch (error) {
        console.error("Error en la solicitud:", error);
        reject(error);
      }
    });
  },

  [ACTION_POST_CREATE_BONUS]: ({ state }, bonus) => {
      
      const formdata = new FormData();
      formdata.append("title", bonus.title);
      formdata.append("business", bonus.business);
      formdata.append("startDate", bonus.startDate);
      formdata.append("endDate", bonus.endDate);
      formdata.append("termsAndConditions", bonus.termsAndConditions);
      formdata.append("businessImage", bonus.businessImage);
      formdata.append("bondImage", bonus.bondImage);
      formdata.append("codeImage", bonus.codeImage);
      return new Promise((resolve, reject) => {
          try {
              state.loading = true;
              axios({
                  method: 'post',
                  url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/bond/create`,
                  headers: {
                      'idEmpresa': sessionStorage.getItem("idEmpresa"),
                      'idUsuario': sessionStorage.getItem("idUsuario")
                  },
                  data: formdata,
                  redirect: 'follow'
              })
                  .then(async (resp) => {
                      // Agrega una condición para verificar si la respuesta fue exitosa

                      if (resp && resp.status === 200) {
                          await Swal.fire({
                              position: 'top-end',
                              icon: 'success',
                              title: 'El bono fue creado exitosamente',
                              showConfirmButton: false,
                              timer: 2500
                          });
                          resolve(resp);
                      } else {
                          // Si la respuesta no es exitosa, puedes manejarlo aquí
                          reject("La petición fue incorrecta o falló");
                      }
                  })
                  .catch(err => {
                      reject(err);
                  })
                  .finally(() => state.loading = false);

          } catch (error) {
              console.error("Error en la solicitud:", error);
              reject(error);
          }
      });
  },

  [ACTION_PUT_UPDATE_BONUS]: async ({ state }, bonus) => {
    
    const formdata = new FormData();
      formdata.append("bondId", bonus.bondId);
      formdata.append("title", bonus.title);
      formdata.append("business", bonus.business);
      formdata.append("startDate", bonus.startDate);
      formdata.append("endDate", bonus.endDate);
      formdata.append("termsAndConditions", bonus.termsAndConditions);
      formdata.append("businessImage", bonus.businessImage);
      formdata.append("bondImage", bonus.bondImage);
      formdata.append("codeImage", bonus.codeImage);

    return await new Promise((resolve, reject) => {
      state.loading = true;
      axios({
        method: 'put',
        url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/bond/update/${bonus.bondId}`,
        headers: {
            'idEmpresa': sessionStorage.getItem("idEmpresa"),
            'idUsuario': sessionStorage.getItem("idUsuario")
        },
        data: formdata,
        redirect: 'follow'
      })
        .then(async (resp) => {
          if (resp && resp.status === 200) {
            await Swal.fire({
              position: "top-end",
              icon: "success",
              title: "El bono fue actualizado exitosamente",
              showConfirmButton: false,
              timer: 2500,
            });

            resolve(resp);
          } else {
            // Si la respuesta no es exitosa, puedes manejarlo aquí
            reject("La petición fue incorrecta o falló");
          }
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => (state.loading = false));
    });
  },

  [ACTION_DELETE_BONUS]: async ({ state }, formData) => {
    state.loading = true;
    return new Promise((resolve, reject) => {
      try {
        state.loading = true;

        const idGroup = sessionStorage.getItem("idGroup");
        const userId = sessionStorage.getItem("idUsuario");
        const companyId = sessionStorage.getItem("idEmpresa");
        BonusService.deleteBond(idGroup, companyId, userId, formData)
          .then(async (resp) => {
            resolve(resp);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            state.loading = false;
          });
      } catch (error) {
        console.error("Error en la solicitud:", error);
        reject(error);
      }
    });
  },
};

export default actions;
